import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";

import "common/css/master.css";
import Header from "common/js/header/header";
import Loader from "common/components/Loader";

import { getTeacherAllocationListSvc, handoverTeacherSvc } from "./handoverSvc";
import FromTeacherTable from "./fromTeacherTbl";
import ToTeacherTable from "./toTeacherTbl";



const TeacherHandover = () => {

    const [loader, setLoader] = useState("none");
    const [opacity, setOpacity] = useState(1);
    const [key, setKey] = useState(0);
    const [lstTeacherAllocation, setLstTeacherAllocation] = useState([]);
    const [fromTeacherAllocationId, setFromTeacherAllocationId] = useState(0);
    const [toTeacherAllocationId, setToTeacherAllocationId] = useState(0);


    useEffect(() => {
        // console.log("TeacherAllocationCtls called");
        getTeacherAllocationList();
    }, [key]);

    const getTeacherAllocationList = () => {
        // console.log("getTeacherAllocationList called");
        setLoader("block");
        setOpacity(0.5);
        getTeacherAllocationListSvc(teacherAllocationListResponse);
    }


    const teacherAllocationListResponse = (data) => {
        // console.log("teacherAllocationListResponse called, data", data);
        if (data.status === "Success") {
            setLstTeacherAllocation(data.lstTchAllocation);
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setLoader("none");
        setOpacity(1);
    }

    const handoverTeacher = () => {
        if (fromTeacherAllocationId === 0) {
            toast.warn("Select for which teacher you have to handover.");
            return;
        }
        if (toTeacherAllocationId === 0) {
            toast.warn("Select which teacher you have to handover.");
            return;
        }
        const userConfirmed = window.confirm("Are you sure you want to handover teacher duties?");
        if (userConfirmed) {
            setLoader("block");
            setOpacity(0.5);
            handoverTeacherSvc(fromTeacherAllocationId, toTeacherAllocationId, handoverTeacherResponse);
        }
    };

    const handoverTeacherResponse = async (data) => {
        // console.log("handoverTeacherResponse called, data", data);
        if (data.status === "Success") {
            toast.success(data.message);
            await updateKey();
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setLoader("none");
        setOpacity(1);
    }


    const handleServiceError = (svcMsg) => {
        if (svcMsg === "You are not Logged In") {
            toast.error("You are not logged in. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else if (svcMsg === "Server Timed Out, Login Again") {
            toast.error("Server timed out. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else {
            toast.error(svcMsg);
        }
    };

    const updateKey = () => {
        setKey(prevKey => prevKey + 1);
    }



    return (
        <div >
            <Header />
            <ToastContainer autoClose={3000} hideProgressBar />
            <Loader loader={loader} position="fixed" />
            <div className="col-md-12 col-xs-12 col-centered padding-remove"
                style={{
                    cursor: (loader === "none") ? 'pointer' : 'none',
                    pointerEvents: (loader === "none") ? 'auto' : 'none',
                    opacity: opacity
                }}>
            </div >
            <div className="col-md-11 col-xs-11 col-centered padding-remove" style={{ marginTop: "20px" }}>
                <div className="col-md-12 col-xs-12 col-centered padding-remove" style={{ display: 'flex', flexDirection: "row" }}>
                    <div className="col-md-6 col-xs-6 col-centered ">
                        <div
                            className="col-sm-6 text-left padding-remove" style={{ fontWeight: "bold", paddingTop: "13px" }}>
                            Outgoing
                        </div>
                        <FromTeacherTable
                            lstTeacherAllocation={lstTeacherAllocation}
                            teacherAllocationId={fromTeacherAllocationId}
                            setTeacherAllocationId={setFromTeacherAllocationId}
                        />
                    </div >
                    <div className="col-md-6 col-xs-6 col-centered">
                        <div
                            className="col-sm-6 text-left padding-remove" style={{ fontWeight: "bold", paddingTop: "13px" }}>
                            Incoming
                        </div>
                        <ToTeacherTable
                            lstTeacherAllocation={lstTeacherAllocation}
                            teacherAllocationId={toTeacherAllocationId}
                            setTeacherAllocationId={setToTeacherAllocationId}
                        />
                    </div >
                </div >
            </div >
            <div className="col-md-12 col-xs-12 col-centered padding-remove" >
                <div className='col-sm-12  padding-remove' style={{ marginTop: "20px" }}>
                    <div className="col-sm-6 col-md-6  padding-remove pull-right">
                        <div className="col-sm-1 col-md-1  padding-remove">
                            <div className="col-sm-12 col-md-12  padding-remove">
                                Note :
                            </div>
                        </div>
                        <div className="col-sm-8 col-md-8  padding-remove">
                            <div className="col-sm-12 col-md-12  padding-remove">
                                <div className="col-sm-12 col-md-12  padding-remove">
                                    Override availability
                                </div>
                                <div className="col-sm-12 col-md-12  padding-remove">
                                    Override eligibility
                                </div>
                                <div className="col-sm-12 col-md-12  padding-remove">
                                    Class teacher role, if any, will also be handed over
                                </div>
                                <div className="col-sm-12 col-md-12  padding-remove">
                                    After handover the "From Teacher" will become unavailable
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-3 col-md-3  padding-remove">
                            <button type="button" className="btn btn-info " onClick={() => handoverTeacher()} >Proceed</button>
                        </div>
                    </div>
                </div>
            </div >
        </div >
    );
}

export default TeacherHandover;






